import { render } from "./activationOwnerForm.vue?vue&type=template&id=54110ea3"
import script from "./activationOwnerForm.vue?vue&type=script&lang=js"
export * from "./activationOwnerForm.vue?vue&type=script&lang=js"

import "./activationOwnerForm.vue?vue&type=style&index=0&id=54110ea3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__